import { toast } from 'react-toastify';
import { RESPONSE_MESSAGE } from '../../../../utils/Constant';
import { MA_LOAI_DOI_TUONG, WAREHOUSE_TYPE } from '../../../constants/Thuoc';
import { IKeVatTu, IVatTuItem, SearchVatTuParams } from '../../../models/VatTuModels';
import { getWarehouse } from '../../../services/ThuocService';
import { searchVatTu } from '../../../services/VatTuService';

export const getListVatTu = async (
	query: SearchVatTuParams,
	setIsLoading?: (flag: boolean) => void
) => {
	try {
		setIsLoading?.(true);

		const response: IVatTuItem[] = await searchVatTu({
			...query,
			pageIndex: 1,
			pageSize: 100,
			isIventoryNoZero: true,
		});
		const result: IKeVatTu[] = response.map((vatTu: IVatTuItem) => ({
			...vatTu,
			id: vatTu.id.toString(),
			donVi: vatTu.unitofMeasureName,
			maVatTu: vatTu.code,
			tenVatTu: vatTu.name,
			giaBhyt: Number(vatTu.bhytPrice),
			giaDichVu: Number(vatTu.servicePrice),
			giaVienPhi: Number(vatTu.hospitalPrice),
			tonKho: Number(vatTu.iventory) - Number(vatTu.peShipment),
			bidId: vatTu.bidId,
			serialNumber: vatTu.serialNumber,
			consignment: vatTu.consignment,
			giaBan: vatTu.salePrice,
			rateHealthInsurance: vatTu.rateHealthInsurance,
		}));

		return result;
	} catch (error) {
		console.error(error);
		toast.error(RESPONSE_MESSAGE.ERROR);
	} finally {
		setIsLoading?.(false);
	}
};

export const getWarehouseByVisitCode = async (visitCode: string, isPatientConclusion?: boolean) => {
	try {
		const isInsuranceObeject = MA_LOAI_DOI_TUONG.BHYT === visitCode;
		const warehouseType = [WAREHOUSE_TYPE.NORMAL];

		if (isInsuranceObeject && !isPatientConclusion) {
			warehouseType.push(WAREHOUSE_TYPE.INSURANCE);
		}

		const response = await getWarehouse({
			warehouseType: warehouseType.join(','),
		});
		return response ?? [];
	} catch (error) {
		console.error(error);
	}
};
